<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<!-- Faixa de ferramentas no padrão do Pipeline de Crédito (card 3066, reunião de 25/09/2026:
     "não dá pra seguir o padrão do nosso pipe atual? o layout, estrutura"). Como lá, NÃO há
     título grande: o breadcrumb já diz onde se está, e a faixa começa pelas ferramentas —
     busca, filtro e a ação principal à direita. O título da tela continua no breadcrumb. -->
<div class="deals-toolbar">
  <div class="deals-toolbar__tools">
    <app-input
      class="deals-toolbar__search"
      [theme]="'medium'"
      [placeholder]="activeBankView() ? 'Pesquisar banco ou empresa...' : 'Pesquisar deals...'"
      [ngModel]="busca()"
      (ngModelChange)="onBuscaChange($event)" />

    <!-- Filtro só na visão interna: o board do parceiro já é um recorte de um parceiro só.
         Múltipla escolha (14/09/2026); nada marcado = todos, e é o `placeholder` que diz
         isso. Sem rótulo em cima, como os seletores da faixa do crédito — o placeholder
         "Parceiro: todos" já nomeia o campo. -->
    <!-- Card 3765: o mesmo seletor do cabeçalho do deal. Na visão dos bancos, os bancos de todos os deals.
         Card 3848: só para o parceiro; o time interno vê os bancos dentro de cada deal. -->
    @if (banksAvailable()) {
      <app-deal-journey-switch
        dealLabel="Jornada dos deals"
        lockedTooltip="Esta visão é liberada quando uma operação for vinculada a um dos seus deals."
        [banksActive]="activeBankView()"
        (journeyChange)="onJourneyChange($event)" />
    }

    @if (!activeBankView() && mostraOrigem() && parceirosDoBoard().length > 0) {
      <app-select
        class="deals-toolbar__filter"
        [theme]="'medium'"
        [placeholder]="'Parceiro: todos'"
        [selectedItemsLabel]="'{0} parceiros'"
        [multiple]="true"
        [maxSelectedLabels]="1"
        [options]="opcoesDeFiltro()"
        [hasFilter]="parceirosDoBoard().length > 6"
        [ngModel]="filtrosDeParceiro()"
        (ngModelChange)="onFiltroDeParceiroChange($event)" />
    }

    @if (!activeBankView()) {
      <p class="deals-toolbar__count">
        {{ totalVisivel() }} {{ totalVisivel() === 1 ? 'deal' : 'deals' }}
        @if (filtrando()) {
          <span class="deals-toolbar__count-total">de {{ deals().length }}</span>
        }
      </p>
    }
  </div>

  <div class="deals-toolbar__actions">
    <app-button
      label="Registrar deal"
      icon="pi pi-plus"
      [size]="'medium'"
      [noMargin]="true"
      routerLink="/dashboard/commercial/register-deal" />
  </div>
</div>

<!-- A dica só existe para quem pode arrastar. Para o parceiro ela seria uma instrução para algo
     que a tela não deixa fazer. -->
@if (activeBankView()) {
  <!-- Card 3765: a Jornada nos bancos de todos os deals, no lugar do quadro de deals. -->
  <app-my-deals-bank-journey [search]="busca()" />
} @else {
  @if (podeArrastar()) {
    <p class="deals-hint">
      <i class="pi pi-arrows-alt" aria-hidden="true"></i>
      Arraste um card para outra coluna para mudar a etapa, ou dentro da coluna para mudar a ordem.
    </p>
  }

  <!-- O board é o `app-kanban-board` compartilhado (card 3213), o mesmo do Pipeline de Crédito. A
       tela só entrega as colunas, as listas e o card; recolher, o arraste (ngx-drag-drop), o skeleton
       e o rodapé de totais por moeda são do componente. Ver o README dele antes de mexer aqui: o card
       é declarado NESTE template de propósito. Rejeitados é uma coluna própria desde o card 3612.

       A Jornada nos bancos, que ficava ao lado do quadro (card 3612), mora dentro do deal desde o card 3707
       (aba Bancos e cartão na Visão geral). -->
  <div class="deals-boards">
    <app-kanban-board
      [columns]="colunas()"
      [loading]="loading()"
      [skeletonColumnCount]="colunas().length"
      [activeItemsOf]="ativosDe"
      [countOf]="contagemDe"
      [totalsOf]="totaisDe"
      [isColumnEmpty]="colunaVazia"
      [isItemDragDisabled]="arrasteTravado"
      [minimizedColumnIds]="colunasRecolhidas()"
      [highlightedColumnId]="dragOverStage()"
      [draggingActive]="arrastando()"
      [hasManyColumns]="true"
      [fillWidth]="true"
      [summaryMinimized]="resumoRecolhido()"
      [dragDisabled]="!podeArrastar()"
      (columnMinimizeToggle)="alternarColuna($any($event.columnId))"
      (summaryToggle)="resumoRecolhido.set(!resumoRecolhido())"
      (itemDragStart)="onDragStart($event.item)"
      (itemDragEnd)="onDragEnd()"
      (columnDragOver)="onDragOver($any($event))"
      (columnDragLeave)="onDragLeave($any($event))"
      (itemDrop)="onDrop($event.column.id, $event.event.data, $event.event.index)">
      <ng-template #kanbanCard let-deal>
        <ng-container *ngTemplateOutlet="cardDeal; context: { $implicit: deal }" />
      </ng-template>
    </app-kanban-board>
  </div>
}

<!-- O card, uma vez só, nas colunas de etapa e na coluna Rejeitados. Quem arrasta é o board
     (`dragDisabled` para o parceiro, `isItemDragDisabled` para o rejeitado); o card só muda o cursor
     (`deal-card--fixo`) para não prometer um gesto que não acontece. -->
<ng-template #cardDeal let-deal>
  <article
    class="deal-card"
    [class.deal-card--fixo]="!podeArrastar() || !!deal.rejectedAt"
    [class.deal-card--rejeitado]="!!deal.rejectedAt"
    [attr.data-tone]="statusTone(deal)"
    [title]="'#' + deal.sequentialId + ' · ' + deal.corporateName"
    (contextmenu)="dealActions.openFromContextMenu($event, deal)">
    <header class="deal-card__head">
      <!-- A PORTA DE ENTRADA da tela do deal. Antes dela só se chegava lá pelo
         botão do e-mail de pré-aprovação — que vai para o PARCEIRO, e só depois
         da pré-aprovação. Na prática, deal em Registro não abria para ninguém, e
         quem é da Legatus não tinha caminho nenhum, apesar de ser justamente quem
         pré-aprova e pede a assinatura.

         É o nome, e não o card inteiro: o card é arrastável, e um link ocupando
         toda a área brigaria com o começo do arrasto. `stopPropagation` pelo
         mesmo motivo das outras ações daqui. -->
      <a
        class="deal-card__company deal-card__company--link"
        [routerLink]="['/dashboard/commercial/my-deals', deal.id]"
        (click)="$event.stopPropagation()"
        draggable="false"
        [title]="'Abrir o deal de ' + deal.corporateName">
        {{ deal.corporateName }}
      </a>

      <!-- Três origens, não duas (card 2937). `partnerId` nulo é o deal que a
         própria Legatus originou para si; com parceiro preenchido ainda há dois
         casos, e é o `origin` que os separa: o parceiro registrou, ou a Legatus
         registrou POR ele ao vincular a empresa — o "Deal manual". -->
      @if (!deal.partnerId) {
        <span class="deal-card__origin">Legatus</span>
      } @else if (deal.origin === 'Manual') {
        <span class="deal-card__origin deal-card__origin--manual">Deal manual</span>
      }

      <!-- Ações do deal (card 3324). As reticências só aparecem para quem tem alguma ação; o
         clique direito no card abre o mesmo menu. `draggable` e `stopPropagation` pelo mesmo
         motivo do link do nome: o card é arrastável. -->
      @if (hasActions(deal)) {
        <button
          type="button"
          class="deal-card__menu"
          title="Ações do deal"
          aria-label="Ações do deal"
          draggable="false"
          (mousedown)="$event.stopPropagation()"
          (click)="dealActions.openFromButton($event, deal)">
          <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
        </button>
      }
    </header>

    <!-- A pílula diz o que se espera acontecer com este deal agora. Deriva da
       etapa e do andamento dos documentos; não há sub-status no backend. -->
    <span class="deal-card__status" [attr.data-color]="statusColor(deal)">
      <i class="deal-card__dot" aria-hidden="true"></i>
      {{ statusLabel(deal) }}
    </span>

    <footer class="deal-card__foot">
      <!-- O valor vira botão para quem pode editá-lo, e texto para quem não pode.
         `canEditAmount` vem RESOLVIDO do servidor: a régua é "interno, ou master
         do parceiro dono", e reimplementá-la aqui criaria uma segunda fonte para
         a mesma pergunta. `stopPropagation` porque o card é arrastável e o começo
         do arrasto engoliria o clique. -->
      @if (deal.canEditAmount) {
        <button
          type="button"
          class="deal-card__amount deal-card__amount--editavel"
          [title]="'Alterar o valor pretendido'"
          draggable="false"
          (click)="$event.stopPropagation(); editarValor(deal)">
          {{ deal.amount | currency: deal.currencyCode : 'symbol' : '1.0-0' : 'pt-BR' }}
          <i class="pi pi-pencil" aria-hidden="true"></i>
        </button>
      } @else {
        <span class="deal-card__amount">
          {{ deal.amount | currency: deal.currencyCode : 'symbol' : '1.0-0' : 'pt-BR' }}
        </span>
      }
      <!-- Nome do parceiro que trouxe o deal. Só no board interno (para o
         parceiro seria sempre o mesmo nome em todo card) e só quando HÁ
         parceiro: no deal da Legatus o selo do topo já diz a origem, e repetir
         embaixo gastava a única linha livre do rodapé. `title` porque o nome é
         truncado com reticências quando não cabe nos 235px da coluna. -->
      @if (mostraOrigem() && origemLabel(deal); as parceiro) {
        <span class="deal-card__owner" [title]="parceiro">{{ parceiro }}</span>
      }
    </footer>

    @if (reservationLabel(deal); as prazo) {
      <p class="deal-card__reservation" [attr.data-tone]="statusTone(deal)">
        {{ prazo }}
      </p>
    }
  </article>
</ng-template>

<!-- Correção do valor pretendido. A modal recarrega o board no sucesso. -->
<app-modal-valor-deal #modalValor (salvou)="carregar()" />

<!-- Motivo da volta de etapa (card 3579): vai na linha do tempo e no e-mail ao parceiro. -->
<app-modal-move-back-stage
  #modalMoveBack
  (confirmed)="onMoveBackConfirmed($event)"
  (cancelled)="onMoveBackCancelled()" />

<!-- Menu de ações do card: um só para o board (card 3324). -->
<app-deal-actions-menu #dealActions (dealDeleted)="removeDeal($event)" />
